export const BRAND_URL = 'https://about.tsuzuku.tokyo/'
export const INSTAGRAM_URL = 'https://www.instagram.com/tsuzuku_tokyo/'
export const PUBLIC_WORKS_URL = 'https://tsuzuku.tokyo/'
export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_ID as string
